import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Datetime from "react-datetime";
// import Swal from "sweetalert2";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import campagnePhysiqueService from "../../../../services/MarketingService/CampagnePhysiqueService";

//Divider

function AddCampagnePhy() {
  const navigate = useNavigate(); // route

  const [nom, setNom] = useState(null);
  const [debutDate, setdebutDate] = useState(null);
  const [finDate, setfinDate] = useState(null);
  const [budget, setBudget] = useState(null);
  const [ville, setVille] = useState(null);
  const [rue, setRue] = useState(null);
  const [pays, setPays] = useState(null);
  const [PiecesJoints, setPiecesJoints] = useState(null);
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [objectif, setObjectif] = useState(null);
  const [objectifsData, setObjectifsData] = useState([]);

  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  //methode d'ajout
  const ajouterCampagnePhysique = async (event) => {
    event.preventDefault();

    // Effectuer des vérifications sur les entrées (nom et objectif)
    if (!nom) {
      // Vérifier si le nom et l'objectif sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    // Si les entrées sont valides, créer un nouvel objet CampagnePhysique
    const nouveauCampagnePhysique = {
      nom: nom,
      objectif: objectif,
      debutDate: debutDate,
      finDate: finDate,
      budget: budget,
      ville: ville,
      rue: rue,
      pays: pays,
    };

    // Créer un objet FormData pour envoyer les données multipart
    const formData = new FormData();
    // formData.append(
    //   "campagnePhysique",
    //   JSON.stringify(nouveauCampagnePhysique)
    // );

    // Ajouter les fichiers joints à formData
    if (piecesJointesdata && piecesJointesdata.length > 0) {
      for (let i = 0; i < piecesJointesdata.length; i++) {
        formData.append("piecesJointes", piecesJointesdata[i]);
      }
    }

    // Appeler la méthode "ajouterPublication()" de "publicationService" en passant formData comme argument
    try {
      campagnePhysiqueService.ajouterCampagnePhysique(
        nouveauCampagnePhysique,
        piecesJointesdata
      ).then((response) => {
        console.log(response.data.success);
        // setSuccess("Ajout validé avec succès !");
        // handleSuccess();

        toastr.success("Ajout validée avec success !! ")

        // setSuccess("Ajout validée avec success !! ");
        setTimeout(() => {
          navigate(`/Campagne/PageCampagnePhy`);
        }, 2000);
        setNom(null);
        setObjectif(null);
        setdebutDate(null);
        setfinDate(null);
        setBudget(null);
        setVille(null);
        setRue(null);
        setPays(null);
        setPiecesJointesdata([]);
      })

    } catch (error) {
      console.log(error); // Afficher l'erreur (optionnel)
      toastr.error("Erreur lors de l'insertion.")

    }
  };

  // methode pour sweetAlert : pour afficher le success de la modification de publication
  // const handleSuccess = () => {
  //   Swal.fire({
  //     icon: "success",
  //     html: `<strong>${success}</strong>`,
  //     toast: true,
  //     position: "top-end",
  //     showConfirmButton: false,
  //     timer: 3000,
  //   });
  // };

  // useEffect(() => {
  //   if (success) {
  //     handleSuccess();
  //   }
  //   if (erreur) {
  //     const timeoutId = setTimeout(() => {
  //       console.log(erreur);
  //     }, 2000); // 30 secondes en millisecondes
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [success, erreur]);

  useEffect(() => {
    AfficherListObjectifs();
  }, []);

  //methode pour afficher objectifs
  const AfficherListObjectifs = async () => {
    try {
      campagnePhysiqueService.AfficherListObjectifs().then((response) => {
        setObjectifsData(response.data.success);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //date
  const handledebutDateChange = (date) => {
    setdebutDate(date);
  };
  const handlefinDateChange = (date) => {
    setfinDate(date);
  };

  //pieces joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);

    // Reset the file input field
    //document.getElementById("pieces-jointes").value = null;
  };

  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne Physique</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/dashboard" style={{ color: "black" }}>Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne" style={{ color: "black" }}>Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne/PageCampagnePhy" style={{ color: "black" }}>Physique</a>
                </li>
                <li className="breadcrumb-item active">Creation</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}
      {/* <Divider /> */}

      {/* content */}
      <section className="content mt-3">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 class="card-title">Ajouter Campagne Physique</h3>
            </div>
            <form onSubmit={ajouterCampagnePhysique}>
              <div class="card-body">
                <div class="form-group">
                  <label for="exampleInputEmail1">Nom</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputEmail1"
                    placeholder="Nom"
                    value={nom}
                    onChange={(event) => setNom(event.target.value)}

                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Objectif</label>
                  <select
                    className="custom-select"
                    id="type"
                    value={objectif}
                    onChange={(e) => setObjectif(e.target.value)}
                  >
                    <option value="">--</option>
                    {objectifsData.map((objectif) => (
                      <option key={objectif} value={objectif}>
                        {objectif}
                      </option>
                    ))}
                  </select>
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Budget</label>
                  <input
                    type="number"
                    class="form-control"
                    id="exampleInputEmail1"
                    placeholder="Budget"
                    value={budget}
                    onChange={(event) => setBudget(event.target.value)}

                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Adresse</label>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="Rue"
                        value={rue}
                        onChange={(event) => setRue(event.target.value)}

                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="Ville"
                        value={ville}
                        onChange={(event) => setVille(event.target.value)}

                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="pays"
                        value={pays}
                        onChange={(event) => setPays(event.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Date Debut</label>
                            <Datetime
                              onChange={handledebutDateChange}
                              value={debutDate}
                              inputProps={{
                                placeholder: "Select date debut and time",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Date Fin</label>
                            <Datetime
                              onChange={handlefinDateChange}
                              value={finDate}
                              inputProps={{
                                placeholder: "Select date fin and time",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <label htmlFor="pieces-jointes">Pieces jointes</label>
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="pieces-jointes"
                          name="pieces-jointes"
                          value={PiecesJoints}
                          onChange={handlePieceJointeChange}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="pieces-jointes"
                        >
                          {piecesJointesdata.length === 0
                            ? "Choose file"
                            : piecesJointesdata
                              .map((fichier) => fichier.name)
                              .join(", ")}
                        </label>
                      </div>
                      {piecesJointesdata.length > 0 && (
                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={handleDeletePieceJointe}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-3">
                    {piecesJointesdata.map((fichier, index) => (
                      <div key={index} className="col-sm-3 text-center mb-3">
                        <img
                          src={URL.createObjectURL(fichier)}
                          alt={fichier.name}
                          style={{ width: "100%", height: "80%" }}
                        />
                        <button
                          className="btn btn-outline-danger col-sm mt-3 mb-3"
                          type="button"
                          onClick={() => handleDeletePieceJointe(index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => navigate("/Campagne/PageCampagnePhy")}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-dark"

                >
                  Ajouter
                </button>
              </div>
            </form>
          </div>
        </div >
      </section >
    </div >
  );
}

export default AddCampagnePhy;
